import React, {useEffect, useState} from 'react';
import Camera from "../Camera/camera";
import ToDoApi from "../API/ToDoApi";

const ToDo = ({setSelectedGoal, House, Floor}) => {
    const [Image, setImage]=useState(null)
    const [cameraOpen, setCameraOpen]=useState(true)
    useEffect(() => {
        if(!cameraOpen){
            setSelectedGoal(null)
        }
    }, [cameraOpen]) 
    useEffect(()=>{
       if(Image) {
           ToDoApi.addImage(Image,House,Floor)
               .then(res=>{
                   if(res.status){
                       alert('Photo was saved')
                       setCameraOpen(false)
                   }
               })
       }
    },[Image])
    return (
        <div>
            {cameraOpen?
            <Camera
             setPicture={setImage}
             setCameraOpen={setCameraOpen}
            />
            :''}
        </div>
    );
};

export default ToDo;